import { EMPTY_ARRAY, Row, Column, RenderConfig, TextInput, TextAreaInput } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	UPDATED_BY: 'updatedby',
	DESCRIPTION: 'description',
	NEW_VALUE: 'newValue',
	UPDATED_AT: 'updatedAt',
	CREATED_AT: 'createdAt',
	GAME_NAME: 'key'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('key')
		.setLabel('Game Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			inputType: 'string'
		}),
	[FORM_FIELD_KEYS.UPDATED_BY]: new RenderConfig()
		.setName('updatedby')
		.setLabel('Updated By')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			inputType: 'string'
		}),
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Description')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			inputType: 'string'
		}),
	[FORM_FIELD_KEYS.NEW_VALUE]: new RenderConfig()
		.setName('newValue')
		.setLabel('New Value')
		.setRenderer(TextAreaInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			inputType: 'string'
		}),
	[FORM_FIELD_KEYS.UPDATED_AT]: new RenderConfig()
		.setName('updatedAt')
		.setLabel('Updated At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss'
		}),
	[FORM_FIELD_KEYS.CREATED_AT]: new RenderConfig()
		.setName('createdAt')
		.setLabel('Created At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss'
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.UPDATED_BY)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.UPDATED_AT)]),
		new Column([new Row(FORM_FIELD_KEYS.CREATED_AT)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.NEW_VALUE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.DESCRIPTION)])])
];
